export default __webpack_public_path__ + "static/media/ameatrophy.1cabbc05.png";